<template>
  <app-layout fullscreen>
    <iframe :src="`panoramas/${$route.params.slug}/index.htm`" class="w-full h-full" frameborder="0" />
    <app-page-menu class="absolute bottom-0 mb-4 transform -translate-x-1/2 left-1/2">
      <app-page-menu-link to="/3-one-bedroom" class="text-center">
        <div>1 Bedroom</div>
        <div>
          22.90 SQ.M.
        </div>
      </app-page-menu-link>
      <app-page-menu-link to="/1-one-bedroom-extra" class="text-center">
        <div>1 Bedroom Extra</div>
        <div>
          28.31 SQ.M.
        </div>
      </app-page-menu-link>
      <app-page-menu-link to="/4-one-bedroom-extra" class="text-center">
        <div>1 Bedroom Extra</div>
        <div>
          25.26 SQ.M.
        </div>
      </app-page-menu-link>
      <app-page-menu-link to="/2-one-bedroom-exclusive-vs" class="text-center">
        <div>Vertical Suite</div>
        <div>
          22.90 SQ.M.
        </div>
      </app-page-menu-link>
    </app-page-menu>
  </app-layout>
</template>
